import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	searchFieldPlaceholder: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.search-field-placeholder',
		defaultMessage: 'Search projects',
		description: 'Placeholder in search field to find projects in Jira',
	},
	searchFieldSearchIconLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.search-field-search-icon-label',
		defaultMessage: 'Search projects',
		description: 'Label description for search icon in search field to find projects in Jira',
	},
	searchFieldClearSearchIconLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.search-field-clear-search-icon-label',
		defaultMessage: 'Clear search',
		description:
			'Label description for cross circle icon in search field to clear the search for projects in Jira',
	},
	allProjectsFilter: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.all-projects-filter',
		defaultMessage: 'All projects',
		description: 'Filter option for displaying all projects in Jira',
	},
	allProjectsFilterDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.all-projects-filter-description',
		defaultMessage: 'All projects in the Jira instance',
		description: 'Description for the filter option to display all projects in Jira',
	},
	existingProjectsFilter: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.existing-projects-filter',
		defaultMessage: 'Existing projects',
		description:
			'Filter option for displaying projects which are already associated with the current priority scheme',
	},
	existingProjectsFilterDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.search-with-filter.existing-projects-filter-description',
		defaultMessage: 'Existing projects in the scheme',
		description:
			'Description for the filter option to display projects which are already associated with the current priority scheme',
	},
});
